import { toast as showToast } from 'react-toastify';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_BUSINESS_BY_ID, GET_BUSINESS_POS_ORDERS_UNPAID, GET_TINYMCE_KEY, GET_BUSINESS_CAMPAIGNS } from './requests';

import { useHistory } from "react-router-dom";
import { useEffect } from 'react';
// import { useParams } from 'react-router-dom';

export const useData = (id, stateId, businessName) => {
  let history = useHistory();
  const [
    onLoadBusiness,
    { loading: isLoading, error, data = { getBusinessById: {} } }
  ] = useLazyQuery(GET_BUSINESS_BY_ID, {
    fetchPolicy: 'no-cache',
  });


  const { getBusinessById: business } = data;

  useEffect(() => {
    if (error || business === null) {
      showToast.error('There was a problem. Data could not be loaded.');
      history.push("/admin");
    }
  }, [error, business, history]);
  return { isLoading, error, business, onLoadBusiness };
};

export const useTinyMCEKey = () => {
  const [
    onLoadTinyMCEKey,
    { data }
  ] = useLazyQuery(GET_TINYMCE_KEY, {
    fetchPolicy: 'no-cache',
    onError: (error) => {
      showToast.error(error?.message || 'There was a problem. Data could not be loaded.');
    },
  });
  const { getTinyMCEPublicKey: tinyMceKey } = data || {};
  return { tinyMceKey, onLoadTinyMCEKey };
};

export const useOrdersCount = () => {
  const [getOrdersCount, { data }] = useMutation(GET_BUSINESS_POS_ORDERS_UNPAID, {
    fetchPolicy: 'no-cache',
    onError: (error) => {
      showToast.error(error?.message || 'There was a problem. Data could not be loaded.');
    },
  });

  const { getBusinessPosOrders: ordersSummary } = data || {};

  return { getOrdersCount, ordersSummary };
};

export const useCampaignsCount = () => {
  const [getCampaignsCount, { data }] = useLazyQuery(GET_BUSINESS_CAMPAIGNS, {
    fetchPolicy: 'no-cache',
    onError: (error) => {
      showToast.error(error?.message || 'There was a problem. Data could not be loaded.');
    },
  });

  const { getCampaigns: campaignsSummary } = data || {};

  return { getCampaignsCount, campaignsSummary };
};